export default __webpack_public_path__ + "static/media/example-spreadsheet-order.9071dafa.xlsx";